import { render, staticRenderFns } from "./templatesoverview.vue?vue&type=template&id=316794b0&scoped=true&lang=pug"
import script from "./templatesoverview.vue?vue&type=script&lang=js"
export * from "./templatesoverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316794b0",
  null
  
)

export default component.exports